import { createStyles } from "antd-style";

export const useHeaderLogoStyles = createStyles(({ token, css }: any) => ({
  logo: css`
    width: 170px;
    display: flex;
    a {
      height: ${token.heightHeader};
      display: inline-flex;
      width: 100%;
    }
  `,
  logoSVG: css`
    font-size: 170px;
  `,
}));
